export default __webpack_public_path__ + "static/media/logo512.d5d85488.png";